import {Injectable} from '@angular/core';
import {AbstractControl, ValidationErrors} from "@angular/forms";

@Injectable({
    providedIn: 'root'
})
export class TinymceService {

    constructor() {

    }

    static getDefaultConfiguration() {
        return {
            inline: false,
            menubar: false,
            statusbar: false,
            browser_spellcheck: true,
            language: 'pt_BR',
            height: 250,
            plugins: "emoticons | link | lists | table",
            toolbar: "fontsizeselect | formatselect	 " +
                "bold italic underline forecolor backcolor | " +
                "alignleft aligncenter alignright alignjustify  |" +
                " numlist bullist outdent indent | emoticons | link	| " +
                "table tabledelete " +
                "| tableprops tablerowprops tablecellprops |" +
                " tableinsertcolbefore tableinsertcolafter tabledeletecol ",
            fontsize_formats: '8pt 10pt 11pt 12pt 14pt 18pt 24pt 36pt'
        };
    }
}
